import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimerComponent {

  timer$ = this._sessionService.sessionTimeout$

  constructor(
    private _sessionService: SessionService
  ) {
  }

  refresh() {
    this._sessionService.refreshSession();
  }
}
